import {Injectable} from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import {SEARCHED_REF_NUMBER} from '../../actions';
import {NgRedux} from 'ng2-redux';
import {IAppState} from '../../store';

@Injectable()
export class SessionService {
  private access_token: string;
  private refresh_token: string;
  private roles: Array<string>;

  constructor(private ngRedux: NgRedux<IAppState>) {
    this.access_token = localStorage.getItem('access_token');
    this.refresh_token = localStorage.getItem('refresh_token');
    this.roles = JSON.parse(localStorage.getItem('roles'));
  }

  setJWT(JWT: Object) {
    this.access_token = JWT['access_token'];
    this.refresh_token = JWT['refresh_token'];

    localStorage.setItem('access_token', this.access_token);
    localStorage.setItem('refresh_token', this.refresh_token);

    this.roles = this.parseJwt(this.access_token)['authorities'];
    localStorage.setItem('roles', JSON.stringify(this.roles));
  }

  clear() {
    this.access_token = null;
    this.refresh_token = null;
    this.roles = null;
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('roles');
    this.ngRedux.dispatch({type: SEARCHED_REF_NUMBER, value: undefined});
  }

  getAccessToken() {
    return this.access_token;
  }

  getRefreshToken() {
    return this.refresh_token;
  }

  getRoles() {
    return this.roles;
  }

  private parseJwt(token: string) {
    return jwt_decode(token);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/session.service.ts